import { RoutePointTypeId } from '@/modules/common/enums/route-point-type-id.enum.ts';
import type { DotColor } from '@/modules/common/types/ui.ts';
import { DeadlineType } from '@/modules/common/enums/deadline-type.ts';
import { DateTime } from 'luxon';
import type { Deadline } from '@/modules/common/types/ui.ts';

export class UnspecifiedContractor {
  readonly tooltip: string;
  readonly dot: DotColor;
  readonly isEditableDeadline: boolean;
  readonly isEditableDescription: boolean;
  readonly defaultId: string;
  readonly deadline: Deadline;
  readonly description: string;
  readonly comment?: string;

  constructor(response: any) {
    this.tooltip = this.getTooltip(response['RPT_ID']);
    this.dot = this.getColor(response['RPT_ID']);
    this.isEditableDeadline = response['Редактируемый срок'] === 1;
    this.isEditableDescription = response['Редактируемое описание'] === 1;
    this.defaultId = `${response['RESPONSIBLE_ID']}_${response['RESPONSIBLE_TABLE_ID']}`;
    this.deadline = this.getDeadline(response);
    this.description = response['Описание'];
    this.comment = response['Примечание'];
  }

  private getTooltip(typeId: RoutePointTypeId) {
    switch (typeId) {
      case RoutePointTypeId.Assignment:
        return 'shared.routePoint.assignment.selectExecutor';
      case RoutePointTypeId.Agreement:
        return 'shared.routePoint.agreement.selectCoordinator';
      case RoutePointTypeId.Notification:
        return 'shared.routePoint.notification.selectUserForNotification';
    }
  }

  private getColor(typeId: RoutePointTypeId): DotColor {
    switch (typeId) {
      case RoutePointTypeId.Assignment:
        return 'green';
      case RoutePointTypeId.Agreement:
        return 'blue';
      case RoutePointTypeId.Notification:
        return 'light-blue';
    }
  }

  private getDeadline(response: any) {
    const days = response['Дней'] ?? 1;
    const date = response['Срок'];

    return {
      type: date ? DeadlineType.Date : DeadlineType.WorkingDays,
      days,
      date: date ? DateTime.fromSQL(date) : DateTime.now().plus({ days }),
    };
  }
}
